import Spinner from '@components/_elements/Spinner/Spinner';
import FormattedAlias from '@components/_shared/Translations/FormattedAlias';
import { Box, Card, SxProps, Theme, Typography } from '@mui/material';
import { CSSProperties, ReactElement, ReactNode } from 'react';

interface UIBoxProps {
  header?: string;
  subheader?: string;
  children?: ReactNode;
  isLoading?: boolean;
  isError?: boolean;
  sx?: SxProps<Theme>;
  style?: CSSProperties;
  headerAction?: ReactNode;
}

const PADDING = 2;
const MARGIN = 2;

const defaultSx = (theme: Theme) => ({
  borderColor: theme.palette.primary.main,
  borderRadius: theme.shape.borderRadius,
  p: PADDING,
  m: MARGIN,
  minHeight: 150,
  height: 'max-content',
});

function UIBox(p: UIBoxProps): ReactElement {
  const renderContent = () => {
    if (p.isLoading) {
      return <Spinner type='content-small' />;
    }
    if (p.isError) {
      return (
        <Typography textAlign='center' marginTop='50px'>
          <FormattedAlias id='Error fetching widget data.' />
        </Typography>
      );
    }
    return p.children;
  };

  const combinedSx = [
    defaultSx,
    ...(Array.isArray(p.sx) ? p.sx : [p.sx]),
  ].filter(Boolean);

  return (
    <Card className='cell' sx={combinedSx} style={p.style || {}}>
      {p.header ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '15px',
          }}
        >
          <Typography variant='h6' sx={{ display: 'inline' }}>
            <FormattedAlias id={p.header} />
            {p.subheader ? (
              <span
                style={{
                  marginLeft: '15px',
                  fontSize: '14px',
                  opacity: 0.5,
                }}
              >
                <FormattedAlias id={p.subheader} />
              </span>
            ) : null}
          </Typography>
          {p.headerAction}
        </Box>
      ) : null}
      {renderContent()}
    </Card>
  );
}

export default UIBox;
